export default __webpack_public_path__ + "static/media/sql-icon.1819c668.png";